import { render, staticRenderFns } from "./SGShardedClusterSummary.vue?vue&type=template&id=6696a4f6&scoped=true"
import script from "./SGShardedClusterSummary.vue?vue&type=script&lang=js"
export * from "./SGShardedClusterSummary.vue?vue&type=script&lang=js"
import style0 from "./SGShardedClusterSummary.vue?vue&type=style&index=0&id=6696a4f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6696a4f6",
  null
  
)

export default component.exports